import { Card, Alert, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

export const AuthorizationCard = ({ styles }) => {
    const navigate = useNavigate();
    return (
        <Card className={` border-0 rounded-3 shadow`} style={{ maxWidth: '380px', margin: '50px auto', ...styles }}>

            <Card.Body className="p-4 ">

                <div className="text-center mb-4">
                    <span role="img" aria-label="Locked" style={{ fontSize: '2.5rem', color: '#6c757d' }}>
                        🔒
                    </span>
                </div>

                <h4 className="text-center fw-medium text-dark mb-3">
                    Permission Required
                </h4>

                <Alert variant="light" className="border text-center p-3 rounded-3">
                    <p className="fw-normal text-dark mb-0">
                        You don't have authorization to view this module details.
                    </p>
                </Alert>

                <p className="text-center text-muted small mt-4 mb-3">
                    Please contact your system administrator or review your user permissions for access.
                </p>

                <div className="d-grid gap-2">
                    <Button variant="btn btn-default" onClick={() => navigate("/dashboard")} size="sm">
                        Return to Dashboard
                    </Button>
                </div>

            </Card.Body>

        </Card>
    );
}